<div class="overlay" [hidden]="!loading">
  <div class="spinner"></div>
</div>
